let chatAudio;
export function unlockChatAudio() {
  const AudioContext=window.AudioContext||window.webkitAudioContext;
  if(!AudioContext)return;
  try {chatAudio ||= new AudioContext();chatAudio.resume().catch(()=>{});}catch{ /* Messages work when audio is restricted. */ }
}
export async function playChatSound() {
  if(chatAudio?.state==='running'){
    const now=chatAudio.currentTime;
    [660,880].forEach((frequency,index)=>{
      const tone=chatAudio.createOscillator(),volume=chatAudio.createGain(),start=now+index*0.12;
      tone.frequency.value=frequency;volume.gain.setValueAtTime(0,start);volume.gain.linearRampToValueAtTime(0.12,start+0.01);volume.gain.exponentialRampToValueAtTime(0.001,start+0.1);
      tone.connect(volume);volume.connect(chatAudio.destination);tone.start(start);tone.stop(start+0.11);tone.onended=()=>{tone.disconnect();volume.disconnect();};
    });
  }else{const audio=new Audio('/sounds/cid_alarm.wav');audio.volume=0.5;await audio.play();}
}
export async function claimChatAlert(owner, id) {
  // An atomic IDB insert deduplicates across tabs, unlike a localStorage read/write.
  if (!window.indexedDB) return false;
  return new Promise(resolve => {
    const open = indexedDB.open('rv-chat-notifications', 1);
    open.onupgradeneeded = () => open.result.createObjectStore('alerts');
    open.onerror = () => resolve(false);
    open.onsuccess = () => {
      const db = open.result, tx = db.transaction('alerts', 'readwrite');
      tx.objectStore('alerts').add(Date.now(), `${owner}:${id}`);
      tx.oncomplete = () => { db.close(); resolve(true); };
      tx.onerror = tx.onabort = () => { db.close(); resolve(false); };
    };
  });
}
export const pushDeviceId = () => {
  let id = localStorage.getItem('cad-chat-device');
  if (!id) { id = crypto.randomUUID(); localStorage.setItem('cad-chat-device', id); }
  return id;
};
let workerSessionVersion = 0;
export async function notifyWorkerSession(userId) {
  const version = ++workerSessionVersion;
  if (!navigator.serviceWorker) return;
  const ready = await navigator.serviceWorker.ready;
  if (version === workerSessionVersion) ready.active?.postMessage({ type: 'CHAT_SESSION', userId: userId || null });
}
export function stopChatPush(token) {
  const device = localStorage.getItem('cad-chat-device');
  if (device && token) fetch(`/api/chat/push/${encodeURIComponent(device)}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` }, keepalive: true }).catch(() => {});
  notifyWorkerSession(null).catch(() => {});
  if (navigator.serviceWorker) navigator.serviceWorker.ready.then(r => r.pushManager?.getSubscription()).then(s => s?.unsubscribe()).catch(() => {});
}
